import { TRACKING_TYPE, toAsciiDigits } from './bhataTrackingApi';

/**
 * Share links carry the lookup, never the answer.
 *
 * Opening one fills the form back in so the only thing left to type is the
 * captcha — which deliberately never travels in the URL, since its token is
 * single-use and tied to the session that fetched the picture.
 */

/** @param {{ mode: number, trackingNo?: string, nid?: string, dateOfBirth?: string }} form */
export function buildBhataTrackingShareUrl(origin, path, form) {
    const params = new URLSearchParams();
    if (Number(form?.mode) === TRACKING_TYPE.byNid) {
        params.set('mode', 'nid');
        if (form.nid) params.set('nid', toAsciiDigits(form.nid));
        if (form.dateOfBirth) params.set('dob', form.dateOfBirth);
    } else {
        if (form?.trackingNo) params.set('id', toAsciiDigits(form.trackingNo));
    }
    const query = params.toString();
    return `${origin}${path}${query ? `?${query}` : ''}`;
}

/** Whether there is anything worth putting in a link yet. */
export function canShareBhataTracking(form) {
    return Number(form?.mode) === TRACKING_TYPE.byNid
        ? Boolean(form?.nid || form?.dateOfBirth)
        : Boolean(form?.trackingNo);
}

/** @returns {{ mode: number, trackingNo: string, nid: string, dateOfBirth: string } | null} */
export function parseBhataTrackingShareParams(search) {
    const params = new URLSearchParams(search || '');
    const id = toAsciiDigits(params.get('id') || '');
    const nid = toAsciiDigits(params.get('nid') || '');
    // Only the date format the API accepts, so a hand-edited link cannot put
    // something unsendable into the field.
    const dobRaw = params.get('dob') || '';
    const dateOfBirth = /^\d{4}-\d{2}-\d{2}$/.test(dobRaw) ? dobRaw : '';

    if (!id && !nid && !dateOfBirth) return null;

    const byNid = params.get('mode') === 'nid' || (!id && (nid || dateOfBirth));
    return {
        mode: byNid ? TRACKING_TYPE.byNid : TRACKING_TYPE.byTrackingNo,
        trackingNo: byNid ? '' : id,
        nid: byNid ? nid : '',
        dateOfBirth: byNid ? dateOfBirth : '',
    };
}
